import * as React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import cx from 'clsx';
import Badge from '@mui/material/Badge';
import { List, ListItemButton } from '@mui/material';
import { WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { getTestAttr } from '@shared/utils/common';
import styles from './NavigationMenu.styles';
import { Item, MENU_LINKS } from './NavigationMenu.constants';
import container from '@core/di';
import { AuthStore } from '@shared/stores';

interface NavigationMenuProps extends WithStyles<typeof styles> {
  notAssignedAssessmentCount: number;
  totalNotApprovedEntitiesCount: number;
}

const NavigationMenu = (props: NavigationMenuProps) => {
  const { classes, totalNotApprovedEntitiesCount, notAssignedAssessmentCount } = props;
  const location = useLocation();
  const authStore = container.get<AuthStore>(AuthStore.diToken);
  const {
    userProfile: { role },
  } = authStore;

  const valuesCount = [totalNotApprovedEntitiesCount, notAssignedAssessmentCount];
  const idsSection = [1, 2];

  const menuRoleItems: Array<Item> = MENU_LINKS.filter(({ roles }) => roles.includes(role));

  return (
    <>
      <List>
        <div className={cx(classes.content, classes.flex, classes.flexColumn)}>
          {menuRoleItems.map(item => {
            const isActive = item.route.split('/')[1] === location.pathname.split('/')[1];

            return (
              <ListItem
                key={item.id}
                disablePadding
                slotProps={{
                  root: { className: classes.listItem },
                }}
              >
                <ListItemButton>
                  <NavLink
                    {...getTestAttr(item.name, 'nav-link', 'btn')}
                    to={item.route}
                    className={cx(
                      classes.navLink,
                      isActive && [classes.fullWidth, classes.activeRouteClass],
                    )}
                  >
                    <ListItemIcon
                      className={cx(
                        classes.listItemIcon,
                        classes.alignItemsCenter,
                        classes.justifyContentCenter,
                      )}
                    >
                      <span className="nav-icon-inactive">{item.icon}</span>
                      <span className="nav-icon-active">{item.activeIcon}</span>
                    </ListItemIcon>
                    <Badge
                      className={classes.badge}
                      badgeContent={
                        <span>
                          +
                          {(item.id === 1 && totalNotApprovedEntitiesCount) ||
                            (item.id === 2 && notAssignedAssessmentCount)}
                        </span>
                      }
                      invisible={!idsSection.includes(item.id) || !valuesCount[item.id - 1]}
                      color="primary"
                      overlap="rectangular"
                    >
                      <ListItemText
                        primary={item.name}
                        classes={{
                          primary: cx(classes.listItemTextRoot, classes.ellipsisText),
                          root: classes.listItemText,
                        }}
                      />
                    </Badge>
                  </NavLink>
                </ListItemButton>
              </ListItem>
            );
          })}
        </div>
      </List>
    </>
  );
};

// `styles` contains an `@global` block, which trips MUI v4's withStyles overload
// resolution under TS 5 and mistypes the wrapped component's props. Assert the
// external prop shape explicitly (the `classes` prop is injected by withStyles).
export default withStyles(styles)(NavigationMenu) as React.ComponentType<
  Pick<NavigationMenuProps, 'notAssignedAssessmentCount' | 'totalNotApprovedEntitiesCount'>
>;
